import React from 'react';
import { RefreshCw, Phone, ShieldCheck } from "lucide-react";

import { Button } from '../../components/tailwind/button';
import { HealthScore } from "../../components/whatsapp/health/HealthScore";
import { QualityRating } from "../../components/whatsapp/health/QualityRating";
import { MessagingLimit } from "../../components/whatsapp/health/MessagingLimit";
import { PolicyViolations } from "../../components/whatsapp/health/PolicyViolations";
import { usePageTitle } from "../../hooks/usePageTitle";

export default function AccountHealth() {
    usePageTitle('Account Health');
    return (
    <div className="max-w-6xl mx-auto p-8 space-y-6">

            {/* Header Section */}
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                    <div className="flex items-center gap-2 px-3 py-1.5 bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-400 rounded-full text-sm font-medium border border-green-100 dark:border-green-900/50">
                        <div className="h-2 w-2 bg-green-500 rounded-full animate-pulse" />
                        Connected
                    </div>
                    <Button variant="outline" size="sm" className="gap-2 bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-800 text-gray-700 dark:text-gray-300">
                        <RefreshCw className="h-3.5 w-3.5" />
                        Refresh Data
                    </Button>
                </div>
            </div>

            {/* Key Metrics Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <HealthScore score={98} />
                <QualityRating rating="High" />
                <MessagingLimit current={842} limit={1000} tier="Tier 1" />
            </div>

            {/* Detailed Sections */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Policy Compliance */}
                <PolicyViolations />

                {/* Account Details Card */}
                <div className="bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-800 rounded-xl p-6 shadow-sm">
                    <div className="flex items-center gap-2 mb-6">
                        <ShieldCheck className="h-5 w-5 text-gray-500 dark:text-gray-400" />
                        <h3 className="font-semibold text-gray-900 dark:text-white">Account Details</h3>
                    </div>

                    <div className="space-y-4">
                        <div className="flex justify-between py-3 border-b border-gray-100 dark:border-slate-800">
                            <span className="text-sm text-gray-500 dark:text-gray-400">WABA ID</span>
                            <span className="text-sm font-mono text-gray-900 dark:text-white">100923847562</span>
                        </div>
                        <div className="flex justify-between py-3 border-b border-gray-100 dark:border-slate-800">
                            <span className="text-sm text-gray-500 dark:text-gray-400">Phone Number</span>
                            <div className="flex items-center gap-2">
                                <Phone className="h-3 w-3 text-gray-400" />
                                <span className="text-sm font-medium text-gray-900 dark:text-white">+91 98765 43210</span>
                            </div>
                        </div>
                        <div className="flex justify-between py-3 border-b border-gray-100 dark:border-slate-800">
                            <span className="text-sm text-gray-500 dark:text-gray-400">Display Name</span>
                            <span className="text-sm font-medium text-gray-900 dark:text-white">Prodyt Business</span>
                        </div>
                        <div className="flex justify-between py-3 border-b border-gray-100 dark:border-slate-800">
                            <span className="text-sm text-gray-500 dark:text-gray-400">Messaging Tier</span>
                            <span className="text-sm font-medium text-blue-600 dark:text-blue-400">1K Daily</span>
                        </div>
                        <div className="flex justify-between py-3">
                            <span className="text-sm text-gray-500 dark:text-gray-400">Payment Method</span>
                            <span className="text-sm font-medium text-gray-900 dark:text-white">Meta Invoice</span>
                        </div>
                    </div>

                    <Button className="w-full mt-6 bg-gray-50 dark:bg-slate-800 text-gray-900 dark:text-white border border-gray-200 dark:border-slate-700 hover:bg-gray-100 dark:hover:bg-slate-700">
                        Manage in Meta Business Suite
                    </Button>
                </div>
            </div>

        </div>
    );
}